/**
 * Default Settings Configuration
 */

import type { Settings } from '../types'

export const DEFAULT_SETTINGS: Settings = {
  practiceMode: 'math',
  mode: 'free',
  theme: 'system',
  wordPractice: {
    enabled: false,
    difficulty: 1,
  },
  celebrations: {
    confetti: true,
  },
  fonts: {
    question: 'large',
    answer: 'large',
  },
  maxValues: {
    multiplication: 10,
    division: 10,
    addition: 20,
    subtraction: 20,
  },
  enabledOperations: {
    multiplication: true,
    division: true,
    addition: false,
    subtraction: false,
  },
  timers: {
    math: 0,
    word: 0,
  },
  lettersPractice: {
    enabled: false,
    level: 1,
  },
}
